"use client"
import React, {useEffect, useState} from 'react'
import Image from "next/image"
import {SearchApiResponse} from "@/types/api/search"
import Spinner from "@/components/ui/loading/Spinner"
import ProductResult from "@/components/ui/search/search-results/product-result"
import RelatedResult from "@/components/ui/search/search-results/related-result"
import BrandResult from "@/components/ui/search/search-results/brand-result"
import CategoryResult from "@/components/ui/search/search-results/category-result"
import {AdvancedSearchService} from "@/http/api/search/AdvancedSearch"
import AdvancedSearchIcon from "@/public/icons/advanced-search.svg"
import {Loader2} from "lucide-react";

const {advancedSearch} = new AdvancedSearchService()

interface SearchResultProps {
    search: string
    onPopularSearchClick: (search: string) => void
}

const POPULAR_SEARCHES = ['شیگلم', 'ضد آفتاب', 'کرم مرطوب کننده', 'ماسک صورت', 'شامپو']

const SearchResult: React.FC<SearchResultProps> = ({search, onPopularSearchClick}) => {
    const [data, setData] = useState<SearchApiResponse | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchSearchData = async () => {
            if (search.trim()) {
                setLoading(true)
                setError(null)
                try {
                    const params: any = {search}
                    const response: any = await advancedSearch(params?.search)
                    setData(response)
                } catch (error) {
                    console.error("Error fetching search results:", error)
                    setError("Failed to fetch search results")
                } finally {
                    setLoading(false)
                }
            } else {
                setData(null)
            }
        }

        fetchSearchData()
    }, [search])

    const addPopularWordHandler = (popularSearch: string) => {
        onPopularSearchClick(popularSearch)

    }

    return (
        <div className="mt-2 p-6 absolute bg-white min-h-[200px] w-[480px] shadow-md rounded-b-2xl">
            {loading ? <div className={"min-h-[540px]"}>
                <h4 className="text-lg">جستجو های پرطرفداری :</h4>
                <div className="w-full mt-3 flex custom-scrollbar p-1 overflow-x-auto gap-5">
                    {POPULAR_SEARCHES.map((popularSearch, index) => (
                        <div
                            key={index}
                            onClick={() => addPopularWordHandler(popularSearch)}
                            className="h-[42px] text-sm border rounded-2xl w-auto p-2.5 whitespace-nowrap cursor-pointer"
                        >
                            {popularSearch}
                        </div>
                    ))}
                </div>
                <div className={"h-[400px] flex flex-col gap-y-4 items-center justify-center"}>
                     <Loader2 className={"animate-spin duration-600 w-10 h-10 text-orange-primary"}/>
                    <div className={"text-sm text-global-text-color  font-normal"}>در حال جستجو ...</div>
                </div>
            </div> : (
                <>
                    {search === "" ? (
                        <div className={"min-h-[540px]"}>
                            <h4 className="text-lg">جستجو های پرطرفداری :</h4>
                            <div className="w-full mt-3 flex custom-scrollbar p-1 overflow-x-auto gap-5">
                                {POPULAR_SEARCHES.map((popularSearch, index) => (
                                    <div
                                        key={index}
                                        onClick={() => addPopularWordHandler(popularSearch)}
                                        className="h-[42px] text-sm border rounded-2xl w-auto p-2.5 whitespace-nowrap cursor-pointer"
                                    >
                                        {popularSearch}
                                    </div>
                                ))}
                            </div>
                            <div className={"h-[400px] flex flex-col gap-y-4 items-center justify-center"}>
                                <Image src={AdvancedSearchIcon || "/placeholder.svg"} alt={"advanced-search"}
                                       width={65} height={65}/>
                                <div className={"text-sm text-global-text-color  font-normal"}>محصول مورد نظر خود را جستجو کنید</div>
                            </div>
                        </div>
                    ) : (
                        <div className={"flex flex-col gap-y-6"}>
                            <ProductResult data={data}/>
                            <RelatedResult data={data}/>
                            <BrandResult data={data}/>
                            <CategoryResult data={data}/>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default SearchResult
